module.exports = __webpack_public_path__ + "static/img/AirPods_1.bbe28170.jpg";